export interface DoubleSwitchConfig {
    checkbox: HTMLInputElement;
    storage: HTMLInputElement;
    tabs: HTMLElement[];
}

export class DoubleSwitch {
    private readonly elements: {
        checkbox: HTMLInputElement,
        storage: HTMLInputElement,
        tabs: HTMLElement[],
    };

    constructor({checkbox, storage, tabs}: DoubleSwitchConfig) {
        this.elements = {checkbox, storage, tabs};
        this.init();
    }

    public switch(): void {
        const {checkbox, storage, tabs} = this.elements;
        storage.value = (checkbox.checked) ? storage.getAttribute(`data-storage`) : ``;
        tabs[0].style.display = (checkbox.checked) ? `block` : `none`;
        tabs[1].style.display = (checkbox.checked) ? `none` : `block`;
    }

    protected init(): void {
        this.switch();
        this.elements.checkbox.addEventListener('change', () => this.switch());
    }
}